import { catchError, filter, mergeMap, of } from 'rxjs'
import type { Epic } from 'Flux/index.js'
import { invitationSlice } from '../../Slice/Invitation/InvitationSlice.js'

export const AcceptInvitationEpic: Epic = (action$, _, { [invitationSlice.name]: invitation, AuthenticationRepository }) => {
  return action$.pipe(
    filter(invitation.acceptInvitationRequest.match),
    mergeMap((action) => {
      return AuthenticationRepository.acceptInvitation(action.payload).pipe(
        mergeMap(() => {
          return of(invitationSlice.actions.acceptInvitationSuccess())
        }),
        catchError(() => {
          return of(invitationSlice.actions.acceptInvitationFailure())
        })
      )
    })
  )
}
